import { NCWalletTabs } from '@capsicum/common';
import { TabBar } from '@capsicum/common-web';
import { ApprovedFooter } from '@capsicum/features/regulations/web';
import styled from 'styled-components';

import { useAdjustDigest, useWalletConnectDigest, useWalletFrontPageStickyOffset } from '../../hooks';
import { useNCWalletTabs } from '../../hooks/components/useNCWalletTabs';
import { useWalletTutorial } from '../../hooks/useWalletTutorial';

export const NCWalletContent = () => {
	const { activeTab, setActiveTab, tabs } = useNCWalletTabs();

	const stickyOffsetTop = useWalletFrontPageStickyOffset();

	useWalletTutorial({ enabled: activeTab === NCWalletTabs.NCTokens });
	useWalletConnectDigest();
	useAdjustDigest();

	return (
		<S.WalletContent>
			<S.TabsContainer>
				<TabBar
					// TODO: as NFTs tab is not final design, recheck this background color when it's final
					backgroundColorVariant={activeTab === NCWalletTabs.NCTokens ? 'light' : 'default'}
					items={tabs}
					preserveState={false}
					selected={activeTab}
					stickyOffsetTop={stickyOffsetTop}
					testID="wallet-tabBar"
					variant="fixed"
					onChangeSelected={setActiveTab}
				/>
				<ApprovedFooter page="wallet" />
			</S.TabsContainer>
		</S.WalletContent>
	);
};

namespace S {
	export const WalletContent = styled.main`
		display: flex;
		flex-flow: column;
		width: 100%;
		height: 100%;
		background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
	`;

	export const TabsContainer = styled.section`
		background-color: ${({ theme }) => theme.colors.backgrounds.main.screen};
		flex-grow: 1;
	`;
}
